import React from 'react';
import VBQLArea from '../../views/VBQLArea';
import FieldButtons from '../../views/FieldButtons';

import SchemaMenu from './SchemaMenu';

export default ({
  chooseQuerySelect,
  queryModel,
  chooseActiveField,
  schema,
  schemaMenuClick,
}) => (
  <>
    <FieldButtons>
      <span className="add-button">
        <SchemaMenu
          root={schema}
          onClick={(item, advanced) => {
            schemaMenuClick(item, 'select', advanced);
          }}
        />
      </span>
    </FieldButtons>
    <div className="cm-size-50">
      {<VBQLArea
        value={queryModel.select}
        placeholder={"Enter the 'SELECT' part of the query"}
        onChange={chooseQuerySelect}
        onFocus={() => chooseActiveField('select')}
      />}
    </div>
  </>
);
